import type { ReactNode } from "react"

import { cn } from "@productlane/lib/src/cn"

const LIST_BANNER_CLASS =
	"mx-3 mb-3 mt-3 flex items-center justify-between gap-3 rounded-[10px] py-2 pl-4 pr-2"

export const ListBanner = ({
	tone,
	label,
	children,
}: {
	tone: "info" | "neutral"
	label: string
	children: ReactNode
}) => (
	<div
		className={cn(
			LIST_BANNER_CLASS,
			tone === "info"
				? "bg-blue-50/70 dark:bg-blue-400/10"
				: "bg-gray-50 dark:bg-gray-850",
		)}
	>
		<span
			className={cn(
				"flex min-w-0 items-center gap-2 text-sm",
				tone === "info" ? "text-blue-700 dark:text-blue-400" : "text-secondary",
			)}
		>
			{tone === "info" && (
				<span className="h-1.5 w-1.5 flex-none rounded-full bg-blue-500" />
			)}
			{label}
		</span>
		<span className="flex flex-none items-center gap-2">{children}</span>
	</div>
)
